import { render, staticRenderFns } from "./SelectInterior.vue?vue&type=template&id=452f3b6a"
import script from "./SelectInterior.vue?vue&type=script&lang=js"
export * from "./SelectInterior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports